<template>
  <div>
    <v-card class="mx-auto">
      <v-card-title
        class="subtitle-1 font-weight-bold"
      >{{ $vuetify.lang.t('$vuetify.profile.title') }}
      </v-card-title>
      <app-form :form="form"></app-form>
    </v-card>
  </div>
</template>

<script>
  import CONSTANTS from '../../helpers/Constants';
  import AppForm from "./Form"

  export default {
    name: "Index",
    data: () => ({
      form: CONSTANTS.defaultProfileForm()
    }),
    components: {
      AppForm
    }
  }
</script>

<style scoped>

</style>